<template>
    <modal name="recuperar-contrasena" :scrollable="true" :height="'auto'" :clickToClose="false">
      <div class="container p-4">
          <div >
            <div class="text-center mb-4">
                <h3 class="with-lines">Recuperar contraseña</h3>
            </div>
              <div class="p-3">
                  <div class="row">
                    <label class="col-sm-2 col-form-label">Usuario:</label>
                    <div class="input-group input-group-sm mb-3 col-sm-10">
                        <input type="text" class="form-control diferentInput" v-model="usuario">
                    </div>
                    
              </div>
            </div>
              <div class="mt-4 text-center">
                  <button class="btn btn-primary col-4" @click="sendUser">Enviar</button>
              </div>
          </div>
      </div>
      </modal> 
  </template>
  
  <script>
  export default {
      data(){
          return{
            usuario: ''
          }
      },
      methods: {
        sendUser(){
            this.$emit('Usuario', this.usuario);
        },
      }
  }
  </script>
  
  <style>
  .btn-primary{
      background-color: #1e536b !important;
      border-color: #1e536b !important;
      border-radius: 15px;
  }
  </style>